import { useLocation } from 'react-router-dom';

export function useListNavigationState() {
  const { pathname, search } = useLocation();

  return () => ({ prevPath: `${pathname}${search}` });
}
